module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ShakeMesh', {
    ref: "@agree@header@title",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@header@title",
      "link": require('./img/header/title1.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.title1 = v
      },
      "exec": function (v) {
        _vm.execStack.title1 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@header@title2",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@header@title2",
      "link": require('./img/header/title2.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.title2 = v
      },
      "exec": function (v) {
        _vm.execStack.titl2 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@agree@bg@rex",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@bg@rex",
      "link": require('./img/bg/rex.png')
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.rexBG = v
      },
      "exec": function (v) {
        _vm.execStack.rexBG = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@tagline@title",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@tagline@title",
      "link": require('./img/tagline/title.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.tagline = v
      },
      "exec": function (v) {
        _vm.execStack.tagline = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@desc@punch-icon",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@desc@punch-icon",
      "link": require('./img/desc/punch-icon.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.punchIcon = v
      },
      "exec": function (v) {
        _vm.execStack.punchIcon = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@desc@punch-about",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@desc@punch-about",
      "link": require('./img/desc/punch-about.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.punchAbout = v
      },
      "exec": function (v) {
        _vm.execStack.punchAbout = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@bg",
    attrs: {
      "vms": "@agree@grunge@bg",
      "gOpacity": 0.53,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeBg = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@punch-icon",
    attrs: {
      "vms": "@agree@grunge@punch-icon",
      "gOpacity": 0.9,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungePunchIcon = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@punch-about",
    attrs: {
      "vms": "@agree@grunge@punch-about",
      "gOpacity": 0.9,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungePunchAbout = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@grunge@enter-now",
    attrs: {
      "vms": "@agree@grunge@enter-now",
      "link": require('./img/enter.png'),
      "gclick": function () {
        _vm.$router.push('/nike/game/login')
      }
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.enterNow = v
      },
      "exec": function (v) {
        _vm.execStack.enterNow = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@box-unchecked",
    attrs: {
      "d-visible": !_vm.checkedBox,
      "gclick": function () {
        _vm.toggleBox()
      },
      "vms": "@agree@agree@box-unchecked",
      "link": require('./img/agree/box-unchecked.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.uncheckBox = v
      },
      "exec": function (v) {
        _vm.execStack.uncheckBox = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@box-checked",
    attrs: {
      "d-visible": _vm.checkedBox,
      "gclick": function () {
        _vm.toggleBox()
      },
      "vms": "@agree@agree@box-checked",
      "link": require('./img/agree/box-checked.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.checkedBox = v
      },
      "exec": function (v) {
        _vm.execStack.checkedBox = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@agree-rule",
    attrs: {
      "gclick": function () {
        _vm.$router.push('/nike/game/rules')
      },
      "vms": "@agree@agree@agree-rule",
      "link": require('./img/agree/agree-rule.png')
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.agreeRule = v
      },
      "exec": function (v) {
        _vm.execStack.agreeRule = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2b0799","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Agree/Agree.vue
// module id = 584
// module chunks = 0